import { ReactElement } from 'react'
import QuestionMarkIcon from './QuestionMarkIcon'
import styled from 'styled-components'

type MoreInfoLinkProps = {
  helpArticleUrl: string
}

const MoreInfoLink = ({ helpArticleUrl }: MoreInfoLinkProps): ReactElement => (
  <LinkWrapper href={helpArticleUrl} rel="noreferrer" target="_blank">
    <QuestionMarkIcon />
  </LinkWrapper>
)

const LinkWrapper = styled.a`
  display: flex;
  align-items: center;
`

export default MoreInfoLink
